import { render, staticRenderFns } from "./k41.vue?vue&type=template&id=6f2dccce&scoped=true"
import script from "./k41.vue?vue&type=script&lang=js"
export * from "./k41.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2dccce",
  null
  
)

export default component.exports